<template>
    <div>
        <v-row class="mb-2 px-2 px-md-4">
            <v-col cols="12">
                <v-card class="pa-4" :color="'#FBFAF1'" outlined>
                    <v-row dense class="mb-2 justify-end">
                       <!-- <v-col cols="12" md="3">
                            <v-text-field v-model="filtros.codigo" label="Código" outlined dense clearable hide-details
                                @keyup.enter="onBuscar" />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-text-field v-model="filtros.codigo_agencia" label="Código agencia" outlined dense
                                clearable hide-details @keyup.enter="onBuscar" />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="filtros.cliente" label="Cliente (nombre, teléfono o email)" outlined
                                dense clearable hide-details @keyup.enter="onBuscar" />
                        </v-col> -->
                        <v-col cols="12" md="auto" class="d-flex justify-end align-center">
                            <v-btn color="blue darken-2" dark :loading="loading" @click="cargarReservas">
                                <v-icon left small>mdi-refresh</v-icon>
                                {{ $t('mensajes.central_reservas.expedientes.refrescar') }}
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-data-table :locale="$i18n.locale" v-if="reservas" :headers="headersTraducidos" :items="reservas"
                        :server-items-length="totalReservas" :options="options" dense
                        class="elevation-1 alternating-rows bordered-table" :loading="loading" :footer-props="{
                            'items-per-page-options': [20, 50, 100],
                            'items-per-page-text': $t('mensajes.central_reservas.expedientes.reservas_por_pagina')
                        }" @update:options="handleUpdateOptions">
                        <template v-slot:body.prepend>
                            <tr class="tabla-filtros-row">
                                <td>
                                    <v-text-field
                                        v-model="filtros.codigo"
                                        dense
                                        outlined
                                        clearable
                                        hide-details
                                        :placeholder="$t('mensajes.central_reservas.expedientes.codigo')"
                                        class="tabla-filtro-input"
                                        @click:clear="onFiltroClear"
                                        @keyup.enter="onBuscar"
                                    />
                                </td>
                                <td>
                                    <v-text-field
                                        v-model="filtros.codigo_agencia"
                                        dense
                                        outlined
                                        clearable
                                        hide-details
                                        :placeholder="$t('mensajes.central_reservas.expedientes.referencia_agencia')"
                                        class="tabla-filtro-input"
                                        @click:clear="onFiltroClear"
                                        @keyup.enter="onBuscar"
                                    />
                                </td>
                                <td>
                                    <v-text-field
                                        v-model="filtros.fecha_inicio"
                                        dense
                                        outlined
                                        clearable
                                        hide-details
                                        :placeholder="$t('mensajes.central_reservas.expedientes.fecha_inicio')"
                                        class="tabla-filtro-input"
                                        @click:clear="onFiltroClear"
                                        @keyup.enter="onBuscar"
                                    />
                                </td>
                                <td>
                                    <v-select
                                        v-model="filtros.estado"
                                        :items="estadosFiltroOptions"
                                        dense
                                        outlined
                                        clearable
                                        hide-details
                                        :placeholder="$t('mensajes.central_reservas.expedientes.estado')"
                                        class="tabla-filtro-input"
                                        @click:clear="onFiltroClear"
                                        @change="onBuscar"
                                    />
                                </td>
                                <td>
                                    <v-text-field
                                        v-model="filtros.cliente"
                                        dense
                                        outlined
                                        clearable
                                        hide-details
                                        :placeholder="$t('mensajes.central_reservas.expedientes.cliente')"
                                        class="tabla-filtro-input"
                                        @click:clear="onFiltroClear"
                                        @keyup.enter="onBuscar"
                                    />
                                </td>
                                <td>
                                    <v-text-field
                                        v-model="filtros.created_at"
                                        dense
                                        outlined
                                        clearable
                                        hide-details
                                        :placeholder="$t('mensajes.central_reservas.expedientes.solicitud')"
                                        class="tabla-filtro-input"
                                        @click:clear="onFiltroClear"
                                        @keyup.enter="onBuscar"
                                    />
                                </td>
                                <td>
                                    <v-text-field
                                        v-model="filtros.cant_peregrinos"
                                        dense
                                        outlined
                                        clearable
                                        hide-details
                                        :placeholder="$t('mensajes.central_reservas.expedientes.peregrinos_corto')"
                                        class="tabla-filtro-input"
                                        @click:clear="onFiltroClear"
                                        @keyup.enter="onBuscar"
                                    />
                                </td>
                                <td>
                                    <v-text-field
                                        v-model="filtros.cant_habitaciones"
                                        dense
                                        outlined
                                        clearable
                                        hide-details
                                        :placeholder="$t('mensajes.central_reservas.expedientes.habitaciones_corto')"
                                        class="tabla-filtro-input"
                                        @click:clear="onFiltroClear"
                                        @keyup.enter="onBuscar"
                                    />
                                </td>
                                <td></td>
                            </tr>
                        </template>

                        <template v-slot:[`item.codigo`]="{ item }">
                            <div class="text-center">
                                {{ item.codigo }}
                            </div>
                        </template>

                        <template v-slot:[`item.fecha_inicio`]="{ item }">
                            <div class="fechas-container">
                                <div class="fecha-inicio">{{ formatearFecha(item.fecha_inicio) }}</div>
                                <div class="fecha-llegada">{{ formatearFecha(item.fecha_llegada) }}</div>
                            </div>
                        </template>

                        <template v-slot:[`item.cliente_camino`]="{ item }">
                            <div>
                                <div class="font-weight-medium">
                                    {{ getClienteNombre(item) }}
                                    <v-icon v-if="item.es_cliente" color="orange" small class="ml-1">mdi-star</v-icon>
                                </div>
                                <div class="subtitle-2 grey--text">{{ getCaminoTitulo(item) }}</div>
                            </div>
                        </template>

                        <template v-slot:[`item.created_at`]="{ item }">
                            {{ formatearFechaConHora(item.created_at) }}
                        </template>

                        <template v-slot:[`item.cant_peregrinos`]="{ item }">
                            <div>
                                <div class="font-weight-medium text-center">{{ item.cant_peregrinos }}</div>
                            </div>
                        </template>

                        <template v-slot:[`item.cant_habitaciones`]="{ on, item }">
                            <div class="habitaciones-icon text-center">
                                <v-icon size="28" :color="'rgb(100, 100, 100, 1)'" v-on="on">mdi-bed</v-icon>
                                <span class="habitaciones-count">{{ getCantidadHabitaciones(item) }}</span>
                            </div>
                        </template>

                        <template v-slot:[`item.estado`]="{ item }">
                            <v-chip label small :color="getEstadoColor(item)">
                                {{ getEstadoNombre(item) || '-' }}
                            </v-chip>
                        </template>

                        <template v-slot:[`item.origen.nombre`]="{ item }">
                            <span>{{ getOrigenNombre(item) }}</span>
                        </template>

                        <template v-slot:[`item.creada_por.inicial`]="{ item }">
                            <span>{{ getInicialCreador(item) }}</span>
                        </template>

                        <template v-slot:[`item.asignada_a.inicial`]="{ item }">
                            <span>{{ getInicialAsignada(item) }}</span>
                        </template>

                        <template v-slot:[`item.actions`]="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on" @click="abrirDetalleReserva(item, { syncRoute: false })">
                                        <v-icon color="blue darken-2">mdi-eye-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $t('mensajes.central_reservas.expedientes.ver_detalle') }}</span>
                            </v-tooltip>
                        </template>

                        <template v-slot:no-data>
                            {{ $t('mensajes.central_reservas.expedientes.sin_datos') }}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="dialogDetalle" max-width="980">
            <v-card class="detalle-reserva-card">
                <v-card-text v-if="loadingDetalle" class="py-12">
                    <div class="d-flex flex-column align-center justify-center">
                        <v-progress-circular indeterminate color="blue darken-2" size="40" />
                        <div class="mt-3 grey--text text--darken-1">{{ $t('mensajes.central_reservas.expedientes.cargando_detalle') }}</div>
                    </div>
                </v-card-text>

                <template v-else-if="reservaSeleccionada">
                <v-card-title class="d-flex align-center justify-space-between">
                    <div>
                        <div class="text-h6 font-weight-bold">{{ $t('mensajes.central_reservas.expedientes.detalle_reserva') }}</div>
                        <div class="text-caption grey--text text--darken-1">
                            {{ reservaSeleccionada.codigo || '-' }} · {{ getCaminoTitulo(reservaSeleccionada) }}
                        </div>
                    </div>
                    <div class="d-flex align-center">
                        <v-btn small outlined color="blue darken-2" class="mr-3" :loading="loadingDetalle" @click="refrescarDetalleReserva">
                            <v-icon left small>mdi-refresh</v-icon>
                            {{ $t('mensajes.central_reservas.expedientes.refrescar') }}
                        </v-btn>
                        <v-btn small color="teal darken-2" dark class="mr-3" @click="abrirDialogHistorial">
                            {{ $t('mensajes.central_reservas.expedientes.ver_historial') }}
                        </v-btn>
                        <v-chip label :color="getEstadoColor(reservaSeleccionada)" class="mr-2">
                            {{ getEstadoNombre(reservaSeleccionada) || $t('mensajes.central_reservas.expedientes.sin_estado') }}
                        </v-chip>
                        <v-btn icon @click="cerrarDetalleReserva">
                            <v-icon color="blue-grey darken-2">mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>

                <v-card-text>
                    <v-row dense>
                        <v-col cols="12" md="6">
                            <v-card
                                v-if="reservaSeleccionada && reservaSeleccionada.asignada_a"
                                outlined
                                class="pa-3 mb-3"
                                :style="getAgenteAsignadoCardStyle(reservaSeleccionada)"
                            >
                            <div class="text-subtitle-2 font-weight-bold mb-2">{{ $t('mensajes.central_reservas.expedientes.agente_asignado') }}</div>
                                <div class="detalle-grid">
                                    <div class="detalle-label">{{ $t('mensajes.central_reservas.expedientes.agente') }}</div>
                                    <div>{{ getAsignadaANombre(reservaSeleccionada) }}</div>
                                    <div class="detalle-label">Email</div>
                                    <div>{{ getAsignadaAEmail(reservaSeleccionada) }}</div>
                                    <div class="detalle-label">{{ $t('mensajes.telefono') }}</div>
                                    <div>{{ getAsignadaATelefono(reservaSeleccionada) }}</div>
                                </div>
                            </v-card>
                            <v-card outlined class="pa-3">
                                <div class="text-subtitle-2 font-weight-bold mb-2">{{ $t('mensajes.datos_reserva.titulo') }}</div>
                                <div class="detalle-grid">
                                    <div class="detalle-label">{{ $t('mensajes.central_reservas.expedientes.codigo') }}</div>
                                    <div>{{ reservaSeleccionada.codigo || '-' }}</div>
                                    <div class="detalle-label">{{ $t('mensajes.central_reservas.expedientes.referencia_agencia') }}</div>
                                    <div>{{ reservaSeleccionada.codigo_agencia || '-' }}</div>
                                    <div class="detalle-label">{{ $t('mensajes.central_reservas.expedientes.codigo_interno') }}</div>
                                    <div>{{ reservaSeleccionada.codigo_reserva || '-' }}</div>
                                    <div class="detalle-label">{{ $t('mensajes.central_reservas.expedientes.inicio') }}</div>
                                    <div>{{ formatearFecha(reservaSeleccionada.fecha_inicio) }}</div>
                                    <div class="detalle-label">{{ $t('mensajes.central_reservas.expedientes.llegada') }}</div>
                                    <div>{{ formatearFecha(reservaSeleccionada.fecha_llegada) }}</div>
                                    <div class="detalle-label">{{ $t('mensajes.central_reservas.expedientes.idioma') }}</div>
                                    <div>{{ reservaSeleccionada.language || '-' }}</div>
                                    <div class="detalle-label">{{ $t('mensajes.central_reservas.expedientes.peregrinos') }}</div>
                                    <div>{{ reservaSeleccionada.cant_peregrinos || 0 }}</div>
                                    <div class="detalle-label">{{ $t('mensajes.central_reservas.expedientes.habitaciones') }}</div>
                                    <div>{{ getCantidadHabitaciones(reservaSeleccionada) }}</div>
                                </div>
                            </v-card>
                            <v-card outlined class="pa-3 mt-3">
                                <div class="d-flex align-center justify-space-between mb-2">
                                    <div class="text-subtitle-2 font-weight-bold">{{ $t('mensajes.central_reservas.expedientes.cliente') }}</div>
                                    <div class="d-flex align-center">
                                        <v-btn
                                            v-if="!editandoCliente"
                                            small
                                            outlined
                                            color="blue darken-2"
                                            @click="iniciarEdicionCliente"
                                        >
                                            <v-icon left small>mdi-pencil</v-icon>
                                            {{ $t('mensajes.central_reservas.expedientes.editar') }}
                                        </v-btn>
                                    </div>
                                </div>

                                <v-alert v-if="errorActualizarCliente" dense text type="error" class="mb-4">
                                    {{ errorActualizarCliente }}
                                </v-alert>
                                <v-alert v-if="clienteActualizadoExitoso" dense text type="success" class="mb-4">
                                    {{ $t('mensajes.central_reservas.expedientes.cliente_actualizado') }}
                                </v-alert>

                                <template v-if="editandoCliente">
                                    <v-row dense>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="formCliente.nombre"
                                                :label="$t('mensajes.nombre')"
                                                outlined
                                                dense
                                                :disabled="guardandoCliente"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="formCliente.apellidos"
                                                :label="$t('mensajes.apellidos')"
                                                outlined
                                                dense
                                                :disabled="guardandoCliente"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="formCliente.email"
                                                label="Email"
                                                outlined
                                                dense
                                                :disabled="guardandoCliente"
                                            />
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="formCliente.telefono"
                                                :label="$t('mensajes.telefono')"
                                                outlined
                                                dense
                                                :disabled="guardandoCliente"
                                            />
                                        </v-col>
                                    </v-row>

                                    <div class="d-flex justify-end">
                                        <v-btn text class="mr-2" :disabled="guardandoCliente" @click="cancelarEdicionCliente">
                                            {{ $t('mensajes.central_reservas.expedientes.cancelar') }}
                                        </v-btn>
                                        <v-btn color="teal darken-2" dark :loading="guardandoCliente" @click="actualizarClienteReserva">
                                            {{ $t('mensajes.central_reservas.expedientes.guardar') }}
                                        </v-btn>
                                    </div>
                                </template>

                                <div v-else class="detalle-grid">
                                    <div class="detalle-label">{{ $t('mensajes.central_reservas.expedientes.cliente') }}</div>
                                    <div>{{ getClienteNombre(reservaSeleccionada) }}</div>
                                    <div class="detalle-label">Email</div>
                                    <div>{{ getClienteEmail(reservaSeleccionada) }}</div>
                                    <div class="detalle-label">{{ $t('mensajes.telefono') }}</div>
                                    <div>{{ getClienteTelefono(reservaSeleccionada) }}</div>
                                </div>
                            </v-card>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-card outlined class="pa-3 h-100">
                                <div class="text-subtitle-2 font-weight-bold mb-2">{{ getCaminoTitulo(reservaSeleccionada) }}</div>
                                <div class="ticket-row">
                                    <span class="detalle-label">{{ $t('mensajes.central_reservas.expedientes.importe_reserva_pvp') }}</span>
                                    <strong>{{ formatImporte(getImporteReservaAjustado(reservaSeleccionada)) }}</strong>
                                </div>
                                <div class="ticket-row">
                                    <span class="detalle-label">{{ $t('mensajes.central_reservas.expedientes.comision_agencia') }}</span>
                                    <strong>{{ formatImporte(getImporteComision(reservaSeleccionada)) }}</strong>
                                </div>
                                <div class="ticket-row">
                                    <span class="detalle-label">{{ $t('mensajes.central_reservas.expedientes.importe_neto_agencia') }}</span>
                                    <strong>{{ formatImporte(getImporteNeto(reservaSeleccionada)) }}</strong>
                                </div>
                                <div class="ticket-description" v-html="formatDescripcionHtml(reservaSeleccionada.descripcion_importe_reserva)" />
                                <div
                                    v-if="tieneDescuentosReserva(reservaSeleccionada)"
                                    class="ticket-description"
                                    v-html="formatDescripcionHtml(getDescripcionDescuentosReserva(reservaSeleccionada))"
                                />

                                <template v-if="tieneServiciosAgregados(reservaSeleccionada)">
                                    <v-divider class="my-3" />

                                    <div class="ticket-row">
                                        <span class="detalle-label">{{ $t('mensajes.central_reservas.expedientes.servicios_agregados_neto') }}</span>
                                        <strong>{{ formatImporteServiciosReserva(reservaSeleccionada) }}</strong>
                                    </div>
                                    <div class="ticket-subtitle">{{ $t('mensajes.datos_reserva.no_comisionable') }}</div>
                                    <div class="ticket-description" v-html="formatDescripcionHtml(getDescripcionImporteServiciosReserva(reservaSeleccionada))" />

                                    <v-divider class="my-3" />

                                    <div class="ticket-row">
                                        <span class="detalle-label">{{ $t('mensajes.central_reservas.expedientes.importe_total_pvp') }}</span>
                                        <strong>{{ formatImporte(getImporteTotalPvp(reservaSeleccionada)) }}</strong>
                                    </div>
                                    <div class="ticket-row">
                                        <span class="detalle-label">{{ $t('mensajes.central_reservas.expedientes.importe_total_neto') }}</span>
                                        <strong>{{ formatImporte(getImporteTotalNeto(reservaSeleccionada)) }}</strong>
                                    </div>
                                </template>
                            </v-card>
                        </v-col>

                        <v-col cols="12">
                            <v-card outlined class="pa-3 mt-2">
                                <div class="d-flex align-center justify-space-between mb-2">
                                    <div class="text-subtitle-2 font-weight-bold">{{ $t('mensajes.central_reservas.expedientes.pasajeros') }}</div>
                                    <v-btn color="blue darken-2" dark small
                                        :href="getLinkRegistroViajeros(reservaSeleccionada)" target="_blank"
                                        rel="noopener noreferrer"
                                        :disabled="!getLinkRegistroViajeros(reservaSeleccionada)">
                                        <v-icon left small>mdi-account-group-outline</v-icon>
                                        {{ $t('mensajes.central_reservas.expedientes.modificar_pasajeros') }}
                                    </v-btn>
                                </div>
                                <v-data-table hide-default-footer dense :headers="headersPasajerosTraducidos"
                                    :items="getPasajerosReserva(reservaSeleccionada)"
                                    :server-items-length="getPasajerosReserva(reservaSeleccionada).length"
                                    class="elevation-1 alternating-rows bordered-table">
                                    <template v-slot:[`item.nombre_completo`]="{ item }">
                                        <span>{{ getNombreCompletoPasajero(item) }}</span>
                                    </template>

                                    <template v-slot:[`item.tipo_documento`]="{ item }">
                                        <span>{{ item.tipo_documento || '-' }}</span>
                                    </template>

                                    <template v-slot:[`item.numero_documento`]="{ item }">
                                        <span>{{ item.numero_documento || '-' }}</span>
                                    </template>

                                    <template v-slot:[`item.telefono_movil`]="{ item }">
                                        <span>{{ item.telefono_movil || '-' }}</span>
                                    </template>

                                    <template v-slot:[`item.email`]="{ item }">
                                        <span>{{ item.email || '-' }}</span>
                                    </template>

                                    <template v-slot:no-data>
                                    {{ $t('mensajes.central_reservas.expedientes.sin_pasajeros') }}
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-col>

                        <v-col cols="12">
                            <v-card outlined class="pa-3 mt-2">
                                <div class="d-flex align-center justify-space-between mb-2 flex-wrap">
                                    <div class="text-subtitle-2 font-weight-bold mr-3">{{ $t('mensajes.central_reservas.expedientes.archivos_reserva') }}</div>
                                    <div class="d-flex align-center flex-wrap">
                                        <v-chip
                                            v-if="cantidadArchivosSeleccionados > 0"
                                            small
                                            outlined
                                            color="blue darken-2"
                                            class="mr-2 mb-1"
                                        >
                                            {{ $tc('mensajes.central_reservas.expedientes.archivos_seleccionados', cantidadArchivosSeleccionados) }}
                                        </v-chip>
                                        <v-btn
                                            small
                                            :color="cantidadArchivosSeleccionados === 0 ? 'blue-grey lighten-3' : 'teal darken-2'"
                                            :dark="cantidadArchivosSeleccionados > 0"
                                            class="mb-1"
                                            :disabled="cantidadArchivosSeleccionados === 0"
                                            @click="abrirDialogEnviarArchivosSeleccionados"
                                        >
                                            <v-icon left small>mdi-email-multiple-outline</v-icon>
                                            {{ $t('mensajes.central_reservas.expedientes.enviar_archivos') }}
                                        </v-btn>
                                    </div>
                                </div>
                                <v-row dense>
                                    <v-col
                                        v-for="seccion in getSeccionesArchivosReserva(reservaSeleccionada)"
                                        :key="seccion.key"
                                        cols="12"
                                    >
                                        <v-card outlined class="pa-3 fill-height">
                                            <div class="text-subtitle-2 font-weight-bold mb-2">{{ seccion.titulo }}</div>
                                            <v-data-table
                                                hide-default-footer
                                                dense
                                                :headers="headersArchivosTraducidos"
                                                :items="seccion.items"
                                            :server-items-length="seccion.items.length"
                                            class="elevation-1 alternating-rows bordered-table"
                                            >
                                                <template v-slot:[`item.seleccion`]="{ item, index }">
                                                    <div class="d-flex justify-center">
                                                        <v-simple-checkbox
                                                            v-if="puedeSeleccionarArchivo(item, seccion, index)"
                                                            :value="isArchivoSeleccionado(item)"
                                                            @input="toggleArchivoSeleccionado(item, seccion, index, $event)"
                                                        />
                                                    </div>
                                                </template>

                                                <template v-slot:[`item.nombre`]="{ item }">
                                                    <span>{{ item.nombre }}</span>
                                                </template>

                                                <template v-slot:[`item.fecha`]="{ item }">
                                                    <span>{{ getFechaArchivoFormateada(item) }}</span>
                                                </template>

                                                <template v-slot:[`item.url`]="{ item, index }">
                                                    <div class="d-flex align-center justify-center flex-wrap archivos-actions">
                                                        <v-chip
                                                            small
                                                            label
                                                            color="blue darken-2"
                                                            dark
                                                            :href="item.url"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            class="mr-2 mb-1"
                                                        >
                                                            {{ $t('mensajes.central_reservas.expedientes.ver') }}
                                                        </v-chip>
                                                        <v-chip
                                                            v-if="puedeEnviarArchivo(item) && puedeMostrarEnviarArchivo(seccion)"
                                                            small
                                                            label
                                                            color="teal darken-2"
                                                            dark
                                                            class="mb-1"
                                                            @click="abrirDialogEnviarArchivo(item)"
                                                        >
                                                            {{ $t('mensajes.central_reservas.expedientes.enviar') }}
                                                        </v-chip>
                                                        <v-menu
                                                            v-if="seccion.key === 'presupuestos' && esUltimoPresupuesto(seccion, item, index)"
                                                            offset-y
                                                            left
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                    icon
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                    class="ml-2 mb-1"
                                                                >
                                                                    <v-icon color="blue darken-2">mdi-dots-vertical</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <v-list dense>
                                                                <v-list-item
                                                                    @click="abrirDialogEnviarArchivo(item)"
                                                                >
                                                                    <v-list-item-title>{{ $t('mensajes.central_reservas.expedientes.enviar_cliente') }}</v-list-item-title>
                                                                </v-list-item>
                                                                <v-list-item
                                                                    @click="abrirDialogSolicitarModificacion(item)"
                                                                >
                                                                    <v-list-item-title>{{ $t('mensajes.central_reservas.expedientes.solicitar_modificacion') }}</v-list-item-title>
                                                                </v-list-item>
                                                                <v-list-item
                                                                    @click="irARegistroViajerosAgencia(reservaSeleccionada)"
                                                                >
                                                                    <v-list-item-title>{{ $t('mensajes.central_reservas.expedientes.solicitar_confirmacion') }}</v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                        </v-menu>
                                                    </div>
                                                </template>

                                                <template v-slot:no-data>
                                                    {{ $t('mensajes.central_reservas.expedientes.sin_archivos') }}
                                                </template>
                                            </v-data-table>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>

                </template>

                <v-card-text v-else class="py-8">
                    <v-alert dense text type="warning" class="mb-0">
                        {{ $t('mensajes.central_reservas.expedientes.error_cargar_detalle') }}
                    </v-alert>
                </v-card-text>

               <!-- <v-card-actions v-if="!loadingDetalle && reservaSeleccionada" class="px-6 pb-4">
                    <v-spacer />
                    <v-btn
                        color="blue darken-2"
                        dark
                        :disabled="!getRutaRegistroViajerosAgencia(reservaSeleccionada)"
                        @click="irARegistroViajerosAgencia(reservaSeleccionada)"
                    >
                        <v-icon left small>mdi-account-arrow-right-outline</v-icon>
                        Confirmar
                    </v-btn>
                </v-card-actions> -->
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogEnviarArchivo" max-width="720" persistent>
            <v-card>
                <v-card-title class="d-flex align-center justify-space-between">
                    <div>
                        <div class="text-h6 font-weight-bold">{{ $t('mensajes.central_reservas.expedientes.enviar_cliente') }}</div>
                        <div class="text-caption grey--text text--darken-1">
                            {{ getResumenArchivosAEnviar() }}
                        </div>
                    </div>
                    <v-btn icon @click="cerrarDialogEnviarArchivo" :disabled="enviandoArchivo">
                        <v-icon color="blue-grey darken-2">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-alert v-if="errorEnvioArchivo" dense text type="error" class="mb-4">
                        {{ errorEnvioArchivo }}
                    </v-alert>
                    <v-alert v-if="envioArchivoExitoso" dense text type="success" class="mb-4">
                        {{ $t('mensajes.central_reservas.expedientes.correo_enviado') }}
                    </v-alert>

                    <v-card v-if="archivosAEnviar.length > 0" outlined class="pa-3 mb-4">
                        <div class="text-subtitle-2 font-weight-bold mb-2">{{ $t('mensajes.central_reservas.expedientes.documentos_seleccionados') }}</div>
                        <div
                            v-for="archivo in archivosAEnviar"
                            :key="getArchivoKey(archivo)"
                            class="d-flex align-center justify-space-between py-1"
                        >
                            <span>{{ archivo.nombre || $t('mensajes.central_reservas.expedientes.documento') }}</span>
                            <span class="text-caption grey--text text--darken-1">{{ archivo.tipo || '-' }}</span>
                        </div>
                    </v-card>

                    <v-text-field
                        v-model="formEnviarArchivo.para"
                        :label="$t('mensajes.central_reservas.expedientes.para')"
                        outlined
                        dense
                        :disabled="enviandoArchivo"
                    />

                    <v-text-field
                        v-model="formEnviarArchivo.asunto"
                        :label="$t('mensajes.central_reservas.expedientes.asunto')"
                        outlined
                        dense
                        :disabled="enviandoArchivo"
                    />

                    <v-textarea
                        v-model="formEnviarArchivo.texto"
                        :label="$t('mensajes.central_reservas.expedientes.texto_correo')"
                        outlined
                        rows="5"
                        auto-grow
                        :disabled="enviandoArchivo"
                    />
                </v-card-text>

                <v-card-actions class="px-6 pb-4">
                    <v-spacer />
                    <v-btn text @click="cerrarDialogEnviarArchivo" :disabled="enviandoArchivo">
                        {{ $t('mensajes.central_reservas.expedientes.cancelar') }}
                    </v-btn>
                    <v-btn color="teal darken-2" dark @click="enviarArchivoPorCorreo" :loading="enviandoArchivo">
                        {{ $t('mensajes.central_reservas.expedientes.enviar') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogContactarAgencia" max-width="720" persistent>
            <v-card>
                <v-card-title class="d-flex align-center justify-space-between">
                    <div>
                        <div class="text-h6 font-weight-bold">{{ tituloDialogAgencia }}</div>
                        <div class="text-caption grey--text text--darken-1">
                            {{ archivoAEnviarAgencia ? archivoAEnviarAgencia.nombre : '-' }}
                        </div>
                    </div>
                    <v-btn icon @click="cerrarDialogContactarAgencia" :disabled="enviandoArchivoAgencia">
                        <v-icon color="blue-grey darken-2">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-alert v-if="errorEnvioArchivoAgencia" dense text type="error" class="mb-4">
                        {{ errorEnvioArchivoAgencia }}
                    </v-alert>
                    <v-alert v-if="envioArchivoAgenciaExitoso" dense text type="success" class="mb-4">
                        {{ $t('mensajes.central_reservas.expedientes.correo_enviado') }}
                    </v-alert>

                    <v-text-field
                        v-model="formContactarAgencia.para"
                        :label="$t('mensajes.central_reservas.expedientes.para')"
                        outlined
                        dense
                    />

                    <v-text-field
                        v-model="formContactarAgencia.asunto"
                        :label="$t('mensajes.central_reservas.expedientes.asunto')"
                        outlined
                        dense
                        :disabled="enviandoArchivoAgencia"
                    />

                    <v-textarea
                        v-model="formContactarAgencia.texto"
                        :label="$t('mensajes.central_reservas.expedientes.mensaje_agencia')"
                        outlined
                        rows="5"
                        auto-grow
                        :disabled="enviandoArchivoAgencia"
                    />
                </v-card-text>

                <v-card-actions class="px-6 pb-4">
                    <v-spacer />
                    <v-btn text @click="cerrarDialogContactarAgencia" :disabled="enviandoArchivoAgencia">
                        {{ $t('mensajes.central_reservas.expedientes.cancelar') }}
                    </v-btn>
                    <v-btn color="teal darken-2" dark @click="enviarCorreoAgenciaRutasMeigas" :loading="enviandoArchivoAgencia">
                        {{ $t('mensajes.central_reservas.expedientes.enviar') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showDialogHistorialCorreo" max-width="900">
            <v-card>
                <v-toolbar dense color="teal darken-2" dark flat>
                    <v-toolbar-title>{{ $t('mensajes.central_reservas.expedientes.detalle_correo') }}</v-toolbar-title>
                    <v-spacer />
                    <v-btn icon @click="showDialogHistorialCorreo = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text class="pt-6">
                    <div class="historial-correo-texto" v-html="historialCorreoTexto"></div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showDialogHistorialAdjuntos" max-width="700">
            <v-card>
                <v-toolbar dense color="teal darken-2" dark flat>
                    <v-toolbar-title>{{ $t('mensajes.central_reservas.expedientes.documentos_adjuntos') }}</v-toolbar-title>
                    <v-spacer />
                    <v-btn icon @click="showDialogHistorialAdjuntos = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text class="pt-4">
                    <v-list two-line>
                        <v-list-item
                            v-for="(adjunto, index) in historialAdjuntos"
                            :key="`${adjunto.url_documento}-${index}`"
                            @click="abrirHistorialAdjuntoDocumento(adjunto)"
                        >
                            <v-list-item-avatar>
                                <v-icon color="primary">mdi-file-pdf</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ adjunto.nombre_documento || `Documento ${index + 1}` }}</v-list-item-title>
                                <v-list-item-subtitle>{{ adjunto.url_documento }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogHistorial" max-width="1100">
            <v-card>
                <v-card-title class="d-flex align-center justify-space-between">
                    <div>
                        <div class="text-h6 font-weight-bold">{{ $t('mensajes.central_reservas.expedientes.historial_reserva') }}</div>
                        <div class="text-caption grey--text text--darken-1">
                            {{ reservaSeleccionada ? reservaSeleccionada.codigo : '-' }}
                        </div>
                    </div>
                    <v-btn icon @click="cerrarDialogHistorial">
                        <v-icon color="blue-grey darken-2">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-row dense>
                        <v-col cols="12">
                            <v-data-table
                                hide-default-footer
                                :locale="$i18n.locale"
                                dense
                                :headers="headersHistorialTraducidos"
                                :items="getHistorialsPorTipo('AGENCIA_RUTASMEIGAS')"
                                :server-items-length="getHistorialsPorTipo('AGENCIA_RUTASMEIGAS').length"
                                class="elevation-1 alternating-rows bordered-table"
                            >
                                <template v-slot:top>
                                    <v-toolbar dense color="teal darken-2" dark flat>
                                        <v-toolbar-title>{{ $t('mensajes.central_reservas.expedientes.historial_agencia_rutas', { agencia: reservaSeleccionada && reservaSeleccionada.origen ? reservaSeleccionada.origen.nombre : $t('mensajes.central_reservas.perfil_agencia') }) }}</v-toolbar-title>
                                    </v-toolbar>
                                </template>

                                <template v-slot:[`item.fecha`]="{ item }">
                                    {{ formatearFechaConHora(getFechaHistorial(item)) }}
                                </template>

                                <template v-slot:[`item.user`]="{ item }">
                                    {{ getNombreUsuarioHistorial(item.user) }}
                                </template>

                                <template v-slot:[`item.descripcion`]="{ item }">
                                    <span class="historial-descripcion" v-html="formatHistorialDescripcion(getDescripcionHistorial(item))"></span>
                                </template>

                                <template v-slot:[`item.mensaje`]="{ item }">
                                    <v-icon
                                        v-if="getHistorialMensaje(item)"
                                        color="primary"
                                        style="cursor: pointer;"
                                        @click="mostrarDialogHistorialCorreo(item)"
                                    >
                                        mdi-email
                                    </v-icon>
                                    <span v-else>-</span>
                                </template>

                                <template v-slot:[`item.adjunto`]="{ item }">
                                    <v-tooltip v-if="getAdjuntoHistorial(item)" bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on" color="primary" style="cursor: pointer;"
                                                @click="verHistorialAdjunto(item)">
                                                mdi-file-pdf
                                            </v-icon>
                                        </template>
                                        <div class="tooltip-content">
                                            {{ $t('mensajes.central_reservas.expedientes.ver_documento') }}
                                        </div>
                                    </v-tooltip>
                                    <span v-else>-</span>
                                </template>

                                <template v-slot:no-data>
                                    {{ $t('mensajes.central_reservas.expedientes.sin_acciones_historial') }}
                                </template>
                            </v-data-table>
                        </v-col>

                        <v-col cols="12">
                            <v-data-table
                                hide-default-footer
                                :locale="$i18n.locale"
                                dense
                                :headers="headersHistorialTraducidos"
                                :items="getHistorialsPorTipo('AGENCIA_CLIENTE')"
                                :server-items-length="getHistorialsPorTipo('AGENCIA_CLIENTE').length"
                                class="elevation-1 alternating-rows bordered-table"
                            >
                                <template v-slot:top>
                                    <v-toolbar dense color="teal darken-2" dark flat>
                                        <v-toolbar-title>{{ $t('mensajes.central_reservas.expedientes.historial_agencia_cliente', { agencia: reservaSeleccionada && reservaSeleccionada.origen ? reservaSeleccionada.origen.nombre : $t('mensajes.central_reservas.perfil_agencia') }) }}</v-toolbar-title>
                                    </v-toolbar>
                                </template>

                                <template v-slot:[`item.fecha`]="{ item }">
                                    {{ formatearFechaConHora(getFechaHistorial(item)) }}
                                </template>

                                <template v-slot:[`item.user`]="{ item }">
                                    {{ getNombreUsuarioHistorial(item.user) }}
                                </template>

                                <template v-slot:[`item.descripcion`]="{ item }">
                                    <span class="historial-descripcion" v-html="formatHistorialDescripcion(getDescripcionHistorial(item))"></span>
                                </template>

                                <template v-slot:[`item.mensaje`]="{ item }">
                                    <v-icon
                                        v-if="getHistorialMensaje(item)"
                                        color="primary"
                                        style="cursor: pointer;"
                                        @click="mostrarDialogHistorialCorreo(item)"
                                    >
                                        mdi-email
                                    </v-icon>
                                    <span v-else>-</span>
                                </template>

                                <template v-slot:[`item.adjunto`]="{ item }">
                                    <v-tooltip v-if="getAdjuntoHistorial(item)" bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on" color="primary" style="cursor: pointer;"
                                                @click="verHistorialAdjunto(item)">
                                                mdi-file-pdf
                                            </v-icon>
                                        </template>
                                        <div class="tooltip-content">
                                            {{ $t('mensajes.central_reservas.expedientes.ver_documento') }}
                                        </div>
                                    </v-tooltip>
                                    <span v-else>-</span>
                                </template>

                                <template v-slot:no-data>
                                    {{ $t('mensajes.central_reservas.expedientes.sin_acciones_historial') }}
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';

export default {
    name: 'ExpedientesSection',
    watch: {
        '$route.query.codigo': {
            async handler() {
                await this.sincronizarDetalleConRuta();
            }
        }
    },
    data() {
        return {
            loading: false,
            loadingDetalle: false,
            reservas: [],
            dialogDetalle: false,
            dialogEnviarArchivo: false,
            dialogContactarAgencia: false,
            dialogHistorial: false,
            showDialogHistorialCorreo: false,
            showDialogHistorialAdjuntos: false,
            reservaSeleccionada: null,
            historialCorreoTexto: '',
            historialAdjuntos: [],
            codigoDetalleActual: '',
            editandoCliente: false,
            guardandoCliente: false,
            clienteActualizadoExitoso: false,
            errorActualizarCliente: '',
            archivoAEnviar: null,
            archivosAEnviar: [],
            archivoAEnviarAgencia: null,
            archivosSeleccionados: [],
            tituloDialogAgencia: 'Contactar Agencia',
            accionDialogAgencia: '',
            enviandoArchivo: false,
            enviandoArchivoAgencia: false,
            envioArchivoExitoso: false,
            envioArchivoAgenciaExitoso: false,
            errorEnvioArchivo: '',
            errorEnvioArchivoAgencia: '',
            formEnviarArchivo: {
                para: '',
                asunto: '',
                texto: ''
            },
            formContactarAgencia: {
                para: '',
                asunto: '',
                texto: ''
            },
            formCliente: {
                nombre: '',
                apellidos: '',
                email: '',
                telefono: ''
            },
            totalReservas: 0,
            options: {
                page: 1,
                itemsPerPage: 20,
                sortBy: ['created_at'],
                sortDesc: [true]
            },
            filtros: {
                codigo: '',
                codigo_agencia: '',
                fecha_inicio: '',
                estado: '',
                cliente: '',
                created_at: '',
                cant_peregrinos: '',
                cant_habitaciones: ''
            },
            colorEstadoCache: {},
            headers: [
                { text: 'CODIGO', value: 'codigo', sortable: true, width: '100px' },
                { text: 'REF_AGENCIA', value: 'codigo_agencia', sortable: true, width: '140px' },
                { text: 'FECHAS CAMINO', align: 'left', sortable: true, value: 'fecha_inicio', width: '160px' },
                { text: 'ESTADO', align: 'center', sortable: true, value: 'estado', width: '130px' },
                { text: 'CLIENTE / CAMINO', align: 'left', sortable: true, value: 'cliente_camino' },
                { text: 'SOLICITUD', align: 'left', sortable: true, value: 'created_at' },
                { text: 'PEREGRINOS', align: 'center', sortable: true, value: 'cant_peregrinos', width: '140px' },
                { text: 'HABITACIONES', align: 'center', sortable: true, value: 'cant_habitaciones', width: '160px' },
                { text: '', width: '50px', value: 'actions', sortable: false, align: 'center' }
            ],
            headersArchivosReserva: [
                { text: '', value: 'seleccion', sortable: false, align: 'center', width: '70px' },
                { text: 'FECHA', value: 'fecha', sortable: false, width: '170px' },
                { text: 'DOCUMENTO', value: 'nombre', sortable: false },
                { text: '', value: 'url', sortable: false, align: 'center', width: '210px' }
            ],
            seccionesArchivosReserva: [
                { key: 'documentos', titulo: 'DOCUMENTOS' },
                { key: 'presupuestos', titulo: 'PRESUPUESTOS' },
                { key: 'confirmaciones', titulo: 'CONFIRMACIONES' },
                { key: 'bonos', titulo: 'BONOS' },
                { key: 'proformas', titulo: 'PROFORMAS' }
            ],
            headersHistorialReserva: [
                { text: 'FECHA', value: 'fecha', sortable: false, width: '170px' },
                { text: 'USUARIO', value: 'user', sortable: false, width: '180px' },
                { text: 'DESCRIPCIÓN', value: 'descripcion', sortable: false },
                { text: 'MENSAJE', value: 'mensaje', sortable: false, align: 'center', width: '90px' },
                { text: 'ADJUNTO', value: 'adjunto', sortable: false, align: 'center', width: '90px' }
            ],
            headersPasajerosReserva: [
                { text: 'NOMBRE', value: 'nombre_completo', sortable: false },
                { text: 'TIPO DOC.', value: 'tipo_documento', sortable: false, width: '110px' },
                { text: 'Nº DOC.', value: 'numero_documento', sortable: false, width: '140px' },
                { text: 'MÓVIL', value: 'telefono_movil', sortable: false, width: '130px' },
                { text: 'EMAIL', value: 'email', sortable: false }
            ]
        };
    },
    computed: {
        ...mapState('auth', ['access_token']),
        headersTraducidos() {
            const t = this.$t.bind(this);
            return [
                { text: t('mensajes.central_reservas.expedientes.codigo'), value: 'codigo', sortable: true, width: '100px' },
                { text: t('mensajes.central_reservas.expedientes.referencia_agencia'), value: 'codigo_agencia', sortable: true, width: '140px' },
                { text: t('mensajes.central_reservas.expedientes.fechas_camino'), align: 'left', sortable: true, value: 'fecha_inicio', width: '160px' },
                { text: t('mensajes.central_reservas.expedientes.estado'), align: 'center', sortable: true, value: 'estado', width: '130px' },
                { text: t('mensajes.central_reservas.expedientes.cliente_camino'), align: 'left', sortable: true, value: 'cliente_camino' },
                { text: t('mensajes.central_reservas.expedientes.solicitud'), align: 'left', sortable: true, value: 'created_at' },
                { text: t('mensajes.central_reservas.expedientes.peregrinos'), align: 'center', sortable: true, value: 'cant_peregrinos', width: '140px' },
                { text: t('mensajes.central_reservas.expedientes.habitaciones'), align: 'center', sortable: true, value: 'cant_habitaciones', width: '160px' },
                { text: '', width: '50px', value: 'actions', sortable: false, align: 'center' }
            ];
        },
        headersArchivosTraducidos() {
            const t = this.$t.bind(this);
            return [
                { text: '', value: 'seleccion', sortable: false, align: 'center', width: '70px' },
                { text: t('mensajes.central_reservas.expedientes.fecha'), value: 'fecha', sortable: false, width: '170px' },
                { text: t('mensajes.central_reservas.expedientes.documento'), value: 'nombre', sortable: false },
                { text: '', value: 'url', sortable: false, align: 'center', width: '210px' }
            ];
        },
        headersPasajerosTraducidos() {
            const t = this.$t.bind(this);
            return [
                { text: t('mensajes.central_reservas.expedientes.nombre'), value: 'nombre_completo', sortable: false },
                { text: t('mensajes.central_reservas.expedientes.tipo_documento'), value: 'tipo_documento', sortable: false, width: '110px' },
                { text: t('mensajes.central_reservas.expedientes.numero_documento'), value: 'numero_documento', sortable: false, width: '140px' },
                { text: t('mensajes.central_reservas.expedientes.movil'), value: 'telefono_movil', sortable: false, width: '130px' },
                { text: 'Email', value: 'email', sortable: false }
            ];
        },
        headersHistorialTraducidos() {
            const t = this.$t.bind(this);
            return [
                { text: t('mensajes.central_reservas.expedientes.fecha'), value: 'fecha', sortable: false, width: '170px' },
                { text: t('mensajes.central_reservas.expedientes.usuario'), value: 'user', sortable: false, width: '180px' },
                { text: t('mensajes.central_reservas.expedientes.descripcion'), value: 'descripcion', sortable: false },
                { text: t('mensajes.central_reservas.expedientes.mensaje'), value: 'mensaje', sortable: false, align: 'center', width: '90px' },
                { text: t('mensajes.central_reservas.expedientes.adjunto'), value: 'adjunto', sortable: false, align: 'center', width: '90px' }
            ];
        },
        estadosFiltroOptions() {
            const estados = this.reservas
                .map(item => this.getEstadoNombre(item))
                .filter(Boolean);

            const unicos = Array.from(new Set(estados));

            if (this.filtros.estado && !unicos.includes(this.filtros.estado)) {
                unicos.push(this.filtros.estado);
            }

            return unicos.sort((a, b) => a.localeCompare(b, this.$i18n.locale, { sensitivity: 'base' }));
        },
        cantidadArchivosSeleccionados() {
            return this.getArchivosSeleccionadosParaEnvio().length;
        }
    },
    async mounted() {
        await this.sincronizarDetalleConRuta(true);
    },
    methods: {
        normalizarCodigo(value) {
            return value ? value.toString().trim().toUpperCase() : '';
        },

        getCodigoRuta() {
            return this.normalizarCodigo(this.$route.query.codigo);
        },

        buscarReservaPorCodigo(codigo) {
            const codigoNormalizado = this.normalizarCodigo(codigo);
            if (!codigoNormalizado) return null;

            return this.reservas.find(item => this.normalizarCodigo(item && item.codigo) === codigoNormalizado) || null;
        },

        actualizarRutaDetalle(codigo) {
            const codigoNormalizado = this.normalizarCodigo(codigo);
            const queryActual = this.$route.query || {};
            const siguienteQuery = {
                ...queryActual,
                tab: 'expedientes'
            };

            if (codigoNormalizado) {
                siguienteQuery.codigo = codigoNormalizado;
            } else {
                delete siguienteQuery.codigo;
            }

            const codigoActual = this.normalizarCodigo(queryActual.codigo);
            const tabActual = queryActual.tab || '';
            if (codigoActual === (codigoNormalizado || '') && tabActual === 'expedientes') return;

            this.$router.replace({ query: siguienteQuery }).catch(() => {});
        },

        async sincronizarDetalleConRuta(isInitialLoad = false) {
            const codigoRuta = this.getCodigoRuta();

            if (!codigoRuta) {
                if (this.dialogDetalle) {
                    this.cerrarDetalleReserva(false);
                    return;
                }

                if (isInitialLoad) {
                    await this.cargarReservas();
                }

                return;
            }

            const filtrosHanCambiado = this.normalizarCodigo(this.filtros.codigo) !== codigoRuta;
            if (filtrosHanCambiado || isInitialLoad) {
                this.filtros.codigo = codigoRuta;
                this.options.page = 1;
                await this.cargarReservas();
            }

            if (this.dialogDetalle && this.codigoDetalleActual === codigoRuta) return;

            const reserva = this.buscarReservaPorCodigo(codigoRuta);
            if (!reserva) return;

            await this.abrirDetalleReserva(reserva, { syncRoute: false });
        },

        buildParams() {
            const sortBy = Array.isArray(this.options.sortBy) ? this.options.sortBy[0] : this.options.sortBy;
            const sortDesc = Array.isArray(this.options.sortDesc) ? this.options.sortDesc[0] : this.options.sortDesc;
            const apiSortBy = this.getApiSortField(sortBy);
            const params = {
                per_page: this.options.itemsPerPage || 20,
                page: this.options.page || 1
            };

            if (this.filtros.codigo) params.codigo = this.filtros.codigo;
            if (this.filtros.codigo_agencia) params.codigo_agencia = this.filtros.codigo_agencia;
            if (this.filtros.fecha_inicio) params.fecha_inicio = this.filtros.fecha_inicio;
            if (this.filtros.estado) params.estado = this.filtros.estado;
            if (this.filtros.cliente) params.cliente = this.filtros.cliente;
            if (this.filtros.created_at) params.created_at = this.filtros.created_at;
            if (this.filtros.cant_peregrinos) params.cant_peregrinos = this.filtros.cant_peregrinos;
            if (this.filtros.cant_habitaciones) params.cant_habitaciones = this.filtros.cant_habitaciones;
            if (apiSortBy) params.sort_by = apiSortBy;
            if (apiSortBy) params.sort_direction = sortDesc ? 'desc' : 'asc';

            return params;
        },

        getApiSortField(sortBy) {
            const sortMap = {
                cliente_camino: 'cliente',
                estado: 'estado'
            };

            return sortMap[sortBy] || sortBy;
        },

        async cargarReservas() {
            this.loading = true;
            try {
                const response = await Vue.axios({
                    method: 'GET',
                    url: '/getReservasModuloAgencias',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + this.access_token
                    },
                    params: this.buildParams()
                });

                const payload = response && response.data ? response.data : {};
                this.reservas = payload.data || [];

                const meta = payload.meta || {};
                this.totalReservas = Number(meta.total || 0);
            } catch (e) {
                this.reservas = [];
                this.totalReservas = 0;
            } finally {
                this.loading = false;
            }
        },

        handleUpdateOptions(newOptions) {
            const currentSortBy = Array.isArray(this.options.sortBy) ? this.options.sortBy[0] : this.options.sortBy;
            const nextSortBy = Array.isArray(newOptions.sortBy) ? newOptions.sortBy[0] : newOptions.sortBy;
            const currentSortDesc = Array.isArray(this.options.sortDesc) ? this.options.sortDesc[0] : this.options.sortDesc;
            const nextSortDesc = Array.isArray(newOptions.sortDesc) ? newOptions.sortDesc[0] : newOptions.sortDesc;
            const changedPage = this.options.page !== newOptions.page;
            const changedPerPage = this.options.itemsPerPage !== newOptions.itemsPerPage;
            const changedSortBy = currentSortBy !== nextSortBy;
            const changedSortDesc = currentSortDesc !== nextSortDesc;
            this.options = { ...this.options, ...newOptions };

            if (changedPage || changedPerPage || changedSortBy || changedSortDesc) {
                this.cargarReservas();
            }
        },

        onBuscar() {
            this.options.page = 1;
            this.cargarReservas();
        },

        async onFiltroClear() {
            await this.$nextTick();
            this.onBuscar();
        },

        onLimpiar() {
            this.filtros = {
                codigo: '',
                codigo_agencia: '',
                fecha_inicio: '',
                estado: '',
                cliente: '',
                created_at: '',
                cant_peregrinos: '',
                cant_habitaciones: ''
            };
            this.options.page = 1;
            this.cargarReservas();
        },

        formatearFecha(fecha) {
            if (!fecha) return '-';
            const d = new Date(fecha);
            if (isNaN(d.getTime())) return fecha;
            return d.toLocaleDateString('es-ES');
        },

        formatearFechaConHora(fecha) {
            if (!fecha) return '-';
            const d = new Date(fecha);
            if (isNaN(d.getTime())) return fecha;
            return d.toLocaleString('es-ES');
        },

        getCantidadHabitaciones(item) {
            if (item.cant_habitaciones != null) {
                return item.cant_habitaciones;
            }

            return Number(item.cant_habitaciones_individuales || 0)
                + Number(item.cant_habitaciones_dobles || 0)
                + Number(item.cant_habitaciones_dobles_matrimoniales || 0)
                + Number(item.cant_habitaciones_triples || 0);
        },

        getEstadoNombre(item) {
            if (!item || !item.estado) return '';
            if (typeof item.estado === 'string') return item.estado;
            return item.estado.estado || item.estado.nombre || '';
        },

        getEstadoColor(item) {
            if (!item || !item.estado || typeof item.estado === 'string') return 'grey lighten-2';
            return item.estado.color || 'grey lighten-2';
        },

        getAgenteAsignadoCardStyle(item) {
            const colorBase = this.resolveColorValue(this.getEstadoColor(item));

            return {
                backgroundColor: this.withAlpha(colorBase, 0.16),
                borderColor: this.withAlpha(colorBase, 0.36)
            };
        },

        resolveColorValue(color) {
            const valor = color ? color.toString().trim() : '';
            if (!valor) return 'rgb(158, 158, 158)';

            if (this.colorEstadoCache[valor]) {
                return this.colorEstadoCache[valor];
            }

            if (/^#/.test(valor)) {
                const convertido = this.hexToRgbString(valor);
                return convertido || 'rgb(158, 158, 158)';
            }

            if (/^rgba?\(/i.test(valor)) {
                return valor;
            }

            if (typeof document !== 'undefined' && document.body) {
                const temporal = document.createElement('div');
                valor.split(/\s+/).filter(Boolean).forEach(clase => temporal.classList.add(clase));
                temporal.style.display = 'none';
                document.body.appendChild(temporal);

                const colorResuelto = window.getComputedStyle(temporal).backgroundColor;
                document.body.removeChild(temporal);

                if (colorResuelto && colorResuelto !== 'transparent' && colorResuelto !== 'rgba(0, 0, 0, 0)') {
                    this.$set(this.colorEstadoCache, valor, colorResuelto);
                    return colorResuelto;
                }
            }

            return 'rgb(158, 158, 158)';
        },

        withAlpha(color, alpha) {
            const valor = this.resolveColorValue(color);
            const coincidencias = valor.match(/[\d.]+/g);

            if (!coincidencias || coincidencias.length < 3) {
                return `rgba(158, 158, 158, ${alpha})`;
            }

            const [red, green, blue] = coincidencias;
            return `rgba(${Number(red)}, ${Number(green)}, ${Number(blue)}, ${alpha})`;
        },

        hexToRgbString(color) {
            const hex = color.replace('#', '').trim();
            const valor = hex.length === 3
                ? hex.split('').map(parte => parte + parte).join('')
                : hex;

            if (!/^[0-9a-fA-F]{6}$/.test(valor)) {
                return null;
            }

            const red = parseInt(valor.slice(0, 2), 16);
            const green = parseInt(valor.slice(2, 4), 16);
            const blue = parseInt(valor.slice(4, 6), 16);

            return `rgb(${red}, ${green}, ${blue})`;
        },

        getClienteNombre(item) {
            const nombre = item && item.cliente && item.cliente.nombre ? item.cliente.nombre : '';
            const apellidos = item && item.cliente && item.cliente.apellidos ? item.cliente.apellidos : '';
            const fullName = `${nombre} ${apellidos}`.trim();
            return fullName || '-';
        },

        getClienteEmail(item) {
            return item && item.cliente && item.cliente.email ? item.cliente.email : '-';
        },

        getClienteTelefono(item) {
            return item && item.cliente && item.cliente.telefono ? item.cliente.telefono : '-';
        },

        getClienteEditable(item) {
            const cliente = item && item.cliente ? item.cliente : {};
            return {
                nombre: cliente && cliente.nombre ? cliente.nombre.toString() : '',
                apellidos: cliente && cliente.apellidos ? cliente.apellidos.toString() : '',
                email: cliente && cliente.email ? cliente.email.toString() : '',
                telefono: cliente && cliente.telefono ? cliente.telefono.toString() : ''
            };
        },

        resetEstadoActualizarCliente() {
            this.errorActualizarCliente = '';
            this.clienteActualizadoExitoso = false;
        },

        resetFormCliente() {
            this.formCliente = this.getClienteEditable(this.reservaSeleccionada);
        },

        iniciarEdicionCliente() {
            this.resetEstadoActualizarCliente();
            this.resetFormCliente();
            this.editandoCliente = true;
        },

        cancelarEdicionCliente() {
            if (this.guardandoCliente) return;
            this.resetEstadoActualizarCliente();
            this.resetFormCliente();
            this.editandoCliente = false;
        },

        getClientePayload() {
            return {
                nombre: this.formCliente.nombre ? this.formCliente.nombre.trim() : '',
                apellidos: this.formCliente.apellidos ? this.formCliente.apellidos.trim() : '',
                email: this.formCliente.email ? this.formCliente.email.trim() : '',
                telefono: this.formCliente.telefono ? this.formCliente.telefono.trim() : ''
            };
        },

        actualizarClienteEnReservas(cliente) {
            if (!cliente || !this.reservaSeleccionada || !this.reservaSeleccionada.id) return;

            this.reservas = this.reservas.map((reserva) => {
                if (!reserva || reserva.id !== this.reservaSeleccionada.id) return reserva;
                return {
                    ...reserva,
                    cliente: {
                        ...(reserva.cliente || {}),
                        ...cliente
                    }
                };
            });
        },

        async actualizarClienteReserva() {
            const reservaId = this.reservaSeleccionada && this.reservaSeleccionada.id ? this.reservaSeleccionada.id : null;
            const cliente = this.getClientePayload();

            this.resetEstadoActualizarCliente();

            if (!reservaId) {
                this.errorActualizarCliente = 'No se pudo identificar la reserva.';
                return;
            }

            if (cliente.email && !this.emailValido(cliente.email)) {
                this.errorActualizarCliente = 'El email del cliente no tiene un formato válido.';
                return;
            }

            if (this.guardandoCliente) return;

            this.guardandoCliente = true;

            try {
                const response = await Vue.axios({
                    method: 'POST',
                    url: '/updateClienteReserva',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + this.access_token
                    },
                    data: {
                        reserva_id: reservaId,
                        cliente
                    }
                });

                const payload = response && response.data ? response.data : {};
                const clienteActualizado = payload && payload.data && payload.data.cliente
                    ? payload.data.cliente
                    : cliente;

                this.reservaSeleccionada = {
                    ...this.reservaSeleccionada,
                    cliente: {
                        ...(this.reservaSeleccionada.cliente || {}),
                        ...clienteActualizado
                    }
                };
                this.actualizarClienteEnReservas(clienteActualizado);
                this.resetFormCliente();
                this.editandoCliente = false;
                this.clienteActualizadoExitoso = true;
            } catch (e) {
                this.errorActualizarCliente = 'No se pudieron actualizar los datos del cliente. Inténtalo de nuevo.';
            } finally {
                this.guardandoCliente = false;
            }
        },

        getCaminoTitulo(item) {
            return item && item.camino && item.camino.titulo ? item.camino.titulo : '-';
        },

        getOrigenNombre(item) {
            return item && item.origen && item.origen.nombre ? item.origen.nombre : '-';
        },

        getInicialCreador(item) {
            return item && item.creada_por && item.creada_por.inicial ? item.creada_por.inicial : '-';
        },

        getInicialAsignada(item) {
            return item && item.asignada_a && item.asignada_a.inicial ? item.asignada_a.inicial : '-';
        },

        getAsignadaANombre(item) {
            const usuario = item && item.asignada_a ? item.asignada_a : null;
            if (!usuario) return '-';
            if (typeof usuario === 'string') return usuario;

            const nombre = usuario.name || usuario.nombre || usuario.first_name || '';
            const apellidos = usuario.apellidos || usuario.last_name || '';
            const nombreCompleto = `${nombre} ${apellidos}`.trim();

            return nombreCompleto || usuario.full_name || usuario.email || usuario.username || '-';
        },

        getAsignadaAEmail(item) {
            const usuario = item && item.asignada_a ? item.asignada_a : null;
            if (!usuario || typeof usuario === 'string') return '-';

            return usuario.email || usuario.correo || usuario.mail || '-';
        },

        getAsignadaATelefono(item) {
            const usuario = item && item.asignada_a ? item.asignada_a : null;
            if (!usuario || typeof usuario === 'string') return '-';
            return usuario.telefono || '-';
        },

        formatImporte(value) {
            if (value == null || value === '') return '-';
            const numero = Number(value);
            if (isNaN(numero)) return `${value} €`;
            return `${numero.toFixed(2)} €`;
        },

        toNumber(value) {
            const numero = Number(value);
            return isNaN(numero) ? 0 : numero;
        },

        getImporteReserva(item) {
            return this.toNumber(item && item.importe_reserva);
        },

        getImporteDescuentosReserva(item) {
            return this.getDescuentosReserva(item)
                .reduce((total, descuento) => total + this.getImporteDescuento(descuento), 0);
        },

        getImporteReservaAjustado(item) {
            return this.getImporteReserva(item) + this.getImporteDescuentosReserva(item);
        },

        getImporteServicios(item) {
            return this.toNumber(item && item.importe_servicios);
        },

        getImporteServiciosAjustado(item) {
            return this.getImporteServicios(item) - this.getImporteDescuentosReserva(item);
        },

        formatImporteServiciosReserva(item) {
            const importeServicios = this.getImporteServiciosAjustado(item);
            if (importeServicios === 0 && this.reservaTieneServiciosPendientes(item)) {
                return '- €';
            }

            return this.formatImporte(importeServicios);
        },

        getImporteTotalPvp(item) {
            const presupuestado = this.toNumber(item && item.importe_presupuestado);
            if (presupuestado > 0) return presupuestado;
            return this.getImporteReservaAjustado(item) + this.getImporteServiciosAjustado(item);
        },

        getImporteComision(item) {
            return this.getImporteReservaAjustado(item) * 0.15;
        },

        getImporteNeto(item) {
            return this.getImporteReservaAjustado(item) - this.getImporteComision(item);
        },

        getImporteTotalNeto(item) {
            return this.getImporteNeto(item) + this.getImporteServiciosAjustado(item);
        },

        formatDescripcionHtml(texto) {
            if (!texto) return '';
            return texto
                .toString()
                .replace(/\n/g, '<br>')
                .replace(/\r/g, '')
                .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        },

        getServiciosNoIncluidosReserva(item) {
            if (!item || !Array.isArray(item.servicios)) return [];
            return item.servicios.filter(servicio => {
                const esNoIncluido = Number(servicio && servicio.esta_incluido) === 0;
                return esNoIncluido && !this.esDescuentoReserva(servicio);
            });
        },

        getDescuentosReserva(item) {
            if (!item || !Array.isArray(item.servicios)) return [];
            return item.servicios.filter(servicio => {
                const esNoIncluido = Number(servicio && servicio.esta_incluido) === 0;
                return esNoIncluido && this.esDescuentoReserva(servicio);
            });
        },

        esDescuentoReserva(servicio) {
            return String(servicio && servicio.tipo_descuento || '').trim().toLowerCase() === 'reserva';
        },

        getImporteDescuento(servicio) {
            const importe = this.toNumber(servicio && servicio.importe);
            return importe > 0 ? -importe : importe;
        },

        tieneDescuentosReserva(item) {
            return this.getDescuentosReserva(item).length > 0;
        },

        tieneServiciosAgregados(item) {
            if (item && Array.isArray(item.servicios)) {
                return this.getServiciosNoIncluidosReserva(item).length > 0
                    || this.getImporteServiciosAjustado(item) !== 0;
            }
            if (this.getImporteServiciosAjustado(item) !== 0) return true;
            return Boolean(item && String(item.descripcion_importe_servicios || '').trim());
        },

        getDescripcionImporteServiciosReserva(item) {
            const servicios = this.getServiciosNoIncluidosReserva(item);
            return this.getDescripcionServiciosReserva(servicios, item);
        },

        getDescripcionDescuentosReserva(item) {
            return this.getDescripcionServiciosReserva(this.getDescuentosReserva(item));
        },

        getDescripcionServiciosReserva(servicios, item = null) {
            if (servicios.length > 0) {
                let descripcion = '';

                for (let servicio of servicios) {
                    const titulo = servicio && servicio.titulo ? servicio.titulo : '';
                    const detalle = servicio && servicio.descripcion ? servicio.descripcion : '';
                    const importe = (this.esDescuentoReserva(servicio)
                        ? this.getImporteDescuento(servicio)
                        : this.toNumber(servicio && servicio.importe)).toFixed(2);

                    if (titulo === 'Traslados extra' || titulo === 'Servicios extra') {
                        descripcion += `• ${titulo}: ${detalle} ..... ${importe} €\n`;
                    } else {
                        descripcion += `• ${titulo} ..... ${importe} €\n`;
                        descripcion += `${detalle}\n`;
                    }
                }

                descripcion += '\n';
                return descripcion;
            }

            const textoOriginal = item && item.descripcion_importe_servicios
                ? item.descripcion_importe_servicios.toString()
                : '';

            if (!textoOriginal) return '';
            return textoOriginal;
        },

        reservaTieneServiciosPendientes(item) {
            if (!item) return false;

            const tienePendientes = item.tienePendientes === true || item.tienePendientes === 1 || item.tienePendientes === '1';
            if (tienePendientes) return true;

            const descripcion = item.descripcion_importe_servicios ? item.descripcion_importe_servicios.toString() : '';
            return /pendiente de tarifa/i.test(descripcion);
        },

        getNombreArchivo(url) {
            if (!url) return 'Documento';
            const limpio = url.toString().split('?')[0];
            const nombre = limpio.substring(limpio.lastIndexOf('/') + 1);
            try {
                return decodeURIComponent(nombre) || 'Documento';
            } catch (e) {
                return nombre || 'Documento';
            }
        },

        normalizarArchivo(item, origen) {
            if (!item) return null;

            if (typeof item === 'string') {
                return {
                    nombre: this.getNombreArchivo(item),
                    url: item,
                    tipo: origen,
                    fecha: null
                };
            }

            const url = item.url_pdf || item.adjunto || item.url || item.path || item.enlace || null;
            if (!url) return null;

            return {
                nombre: item.documento || item.nombre || item.titulo || this.getNombreArchivo(url) || origen,
                url,
                tipo: origen,
                fecha: item.fecha || item.created_at || item.updated_at || item.fecha_creacion || null
            };
        },

        getFechaArchivoFormateada(archivo) {
            if (!archivo || !archivo.fecha) return '-';
            const d = new Date(archivo.fecha);
            if (isNaN(d.getTime())) return archivo.fecha;

            const fecha = d.toLocaleDateString('es-ES');
            const hora = d.toLocaleTimeString('es-ES', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            });

            return `${fecha} ${hora}`;
        },

        isArchivoVisibleAgencia(item) {
            if (!item || typeof item !== 'object') return false;

            const visible = item.is_visible_agencia;
            if (visible === true || visible === 1) return true;
            if (typeof visible === 'string') {
                const normalizado = visible.trim().toLowerCase();
                return normalizado === 'true' || normalizado === '1';
            }

            return false;
        },

        getPasajerosReserva(reserva) {
            if (!reserva || !Array.isArray(reserva.pasajeros)) return [];
            return reserva.pasajeros;
        },

        getNombreCompletoPasajero(pasajero) {
            if (!pasajero) return '-';
            const nombre = pasajero.nombre || '';
            const primerApellido = pasajero.primer_apellido || '';
            const segundoApellido = pasajero.segundo_apellido || '';
            const nombreCompleto = `${nombre} ${primerApellido} ${segundoApellido}`.trim();
            return nombreCompleto || '-';
        },

        getUrlCaminoPorIdioma(camino, baseKey, language) {
            if (!camino || !baseKey) return null;

            const idioma = language ? language.toString().trim().toUpperCase() : '';
            if (idioma && idioma !== 'ES') {
                const urlIdioma = camino[`${baseKey}_${idioma}`];
                if (urlIdioma) return urlIdioma;
            }

            return camino[baseKey] || null;
        },

        emailValido(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').toLowerCase());
        },

        abrirDialogHistorial() {
            this.dialogHistorial = true;
        },

        async refrescarDetalleReserva() {
            if (!this.reservaSeleccionada || !this.reservaSeleccionada.id || this.loadingDetalle) return;

            const reservaId = this.reservaSeleccionada.id;
            const detalleAnterior = this.reservaSeleccionada;

            this.loadingDetalle = true;

            try {
                const detalleReserva = await this.obtenerDetalleReserva(reservaId);
                this.reservaSeleccionada = detalleReserva || detalleAnterior;
            } catch (e) {
                this.reservaSeleccionada = detalleAnterior;
            } finally {
                this.loadingDetalle = false;
            }
        },

        async refrescarTrasEnvioCorreo() {
            await this.refrescarDetalleReserva();
        },

        cerrarDialogHistorial() {
            this.dialogHistorial = false;
        },

        getHistorialsReserva() {
            return this.reservaSeleccionada && Array.isArray(this.reservaSeleccionada.historials)
                ? this.reservaSeleccionada.historials
                : [];
        },

        getFechaHistorial(item) {
            return item && (item.fecha || item.created_at) ? item.fecha || item.created_at : null;
        },

        getHistorialsPorTipo(tipo) {
            return this.getHistorialsReserva()
                .filter(item => item && item.tipo === tipo)
                .slice()
                .sort((a, b) => {
                    const fechaA = new Date(this.getFechaHistorial(a) || 0).getTime();
                    const fechaB = new Date(this.getFechaHistorial(b) || 0).getTime();
                    return fechaA - fechaB;
                });
        },

        getNombreUsuarioHistorial(user) {
            if (!user) return '-';

            if (typeof user === 'string') return user;

            const nombre = user.name || user.nombre || '';
            const apellidos = user.apellidos || '';
            const nombreCompleto = `${nombre} ${apellidos}`.trim();

            return nombreCompleto || user.email || user.username || '-';
        },

        getDescripcionHistorial(item) {
            if (!item) return null;

            if (item.descripcion_agencia !== null && item.descripcion_agencia !== undefined) {
                return item.descripcion_agencia;
            }

            return item.descripcion;
        },

        formatHistorialDescripcion(descripcion) {
            if (!descripcion) return '-';

            return descripcion
                .toString()
                .replace(/\n/g, '<br>')
                .replace(/\r/g, '');
        },

        getHistorialMensaje(item) {
            if (!item) return '';

            const partes = [];

            if (item.remitente) {
                partes.push(`<strong>De:</strong> ${this.escapeHtml(item.remitente)}`);
            }

            if (item.destinatario) {
                partes.push(`<strong>Para:</strong> ${this.escapeHtml(item.destinatario)}`);
            }

            if (item.asunto) {
                partes.push(`<strong>Asunto:</strong> ${this.escapeHtml(item.asunto)}`);
            }

            const contenido = item.contenido || item.mensaje || item.texto_correo || '';

            if (contenido) {
                partes.push(contenido);
            }

            return partes.join('<br>');
        },

        mostrarDialogHistorialCorreo(item) {
            this.historialCorreoTexto = this.getHistorialMensaje(item);
            this.showDialogHistorialCorreo = true;
        },

        getHistorialAdjuntos(item) {
            const adjunto = item && (item.adjunto || item.url_archivo || item.url);

            if (!adjunto) {
                return [];
            }

            if (Array.isArray(adjunto)) {
                return adjunto
                    .map((documento, index) => ({
                        nombre_documento: (documento && (documento.nombre_documento || documento.nombre)) || `Documento ${index + 1}`,
                        url_documento: (documento && (documento.url_documento || documento.url)) || ''
                    }))
                    .filter(documento => documento.url_documento);
            }

            if (typeof adjunto === 'string') {
                const valor = adjunto.trim();

                if (!valor) {
                    return [];
                }

                if (valor.startsWith('[') || valor.startsWith('{')) {
                    try {
                        const parsed = JSON.parse(valor);
                        return this.getHistorialAdjuntos({ adjunto: parsed });
                    } catch (e) {
                        return [{
                            nombre_documento: 'Documento',
                            url_documento: valor
                        }];
                    }
                }

                return [{
                    nombre_documento: 'Documento',
                    url_documento: valor
                }];
            }

            if (typeof adjunto === 'object') {
                const urlDocumento = adjunto.url_documento || adjunto.url || '';

                if (!urlDocumento) {
                    return [];
                }

                return [{
                    nombre_documento: adjunto.nombre_documento || adjunto.nombre || 'Documento',
                    url_documento: urlDocumento
                }];
            }

            return [];
        },

        getAdjuntoHistorial(item) {
            const adjuntos = this.getHistorialAdjuntos(item);
            return adjuntos.length > 0 ? adjuntos[0].url_documento : null;
        },

        abrirHistorialAdjuntoDocumento(adjunto) {
            if (adjunto && adjunto.url_documento) {
                window.open(adjunto.url_documento, '_blank', 'noopener,noreferrer');
            }
        },

        verHistorialAdjunto(item) {
            const adjuntos = this.getHistorialAdjuntos(item);

            if (adjuntos.length === 1) {
                this.abrirHistorialAdjuntoDocumento(adjuntos[0]);
                return;
            }

            if (adjuntos.length > 1) {
                this.historialAdjuntos = adjuntos;
                this.showDialogHistorialAdjuntos = true;
            }
        },

        escapeHtml(text) {
            return String(text).replace(/[&<>"']/g, char => {
                switch (char) {
                case '&':
                    return '&amp;';
                case '<':
                    return '&lt;';
                case '>':
                    return '&gt;';
                case '"':
                    return '&quot;';
                case '\'':
                    return '&#39;';
                default:
                    return char;
                }
            });
        },

        puedeEnviarArchivo(archivo) {
            return !!archivo && archivo.tipo !== 'Proforma';
        },

        puedeMostrarEnviarArchivo(seccion) {
            if (!seccion || !seccion.key) return false;

            return ['documentos', 'bonos', 'confirmaciones'].includes(seccion.key);
        },

        getArchivoKey(archivo) {
            return archivo && archivo.url ? archivo.url.toString().trim() : '';
        },

        puedeSeleccionarArchivo(archivo, seccion, index = null) {
            if (!archivo || !seccion) return false;
            if (seccion.key === 'presupuestos') {
                return this.esUltimoPresupuesto(seccion, archivo, index);
            }
            return this.puedeEnviarArchivo(archivo) && this.puedeMostrarEnviarArchivo(seccion);
        },

        isArchivoSeleccionado(archivo) {
            const key = this.getArchivoKey(archivo);
            return !!key && this.archivosSeleccionados.includes(key);
        },

        toggleArchivoSeleccionado(archivo, seccion, index, checked) {
            const key = this.getArchivoKey(archivo);
            if (!key || !this.puedeSeleccionarArchivo(archivo, seccion, index)) return;

            const seleccionado = checked === true;
            const yaSeleccionado = this.archivosSeleccionados.includes(key);

            if (seleccionado && !yaSeleccionado) {
                this.archivosSeleccionados = [...this.archivosSeleccionados, key];
                return;
            }

            if (!seleccionado && yaSeleccionado) {
                this.archivosSeleccionados = this.archivosSeleccionados.filter(item => item !== key);
            }
        },

        limpiarArchivosSeleccionados() {
            this.archivosSeleccionados = [];
        },

        getArchivosSeleccionadosParaEnvio() {
            if (!this.reservaSeleccionada || this.archivosSeleccionados.length === 0) return [];

            const seleccionados = [];
            const keys = new Set(this.archivosSeleccionados);
            const secciones = this.getSeccionesArchivosReserva(this.reservaSeleccionada);

            for (const seccion of secciones) {
                for (let index = 0; index < seccion.items.length; index++) {
                    const item = seccion.items[index];
                    const key = this.getArchivoKey(item);
                    if (!key || !keys.has(key) || !this.puedeSeleccionarArchivo(item, seccion, index)) continue;
                    seleccionados.push(item);
                }
            }

            return seleccionados;
        },

        inicializarDialogEnviarArchivo(archivos, paraDestino = null) {
            if (!Array.isArray(archivos) || archivos.length === 0) return;
            const paraPorDefecto = this.getClienteEmail(this.reservaSeleccionada) !== '-'
                ? this.getClienteEmail(this.reservaSeleccionada)
                : '';

            this.archivosAEnviar = archivos;
            this.archivoAEnviar = archivos.length === 1 ? archivos[0] : null;
            this.dialogEnviarArchivo = true;
            this.enviandoArchivo = false;
            this.envioArchivoExitoso = false;
            this.errorEnvioArchivo = '';
            this.formEnviarArchivo = {
                para: paraDestino || paraPorDefecto,
                asunto: '',
                texto: ''
            };
        },

        abrirDialogEnviarArchivo(archivo, paraDestino = null) {
            if (!archivo || !archivo.url) return;
            this.inicializarDialogEnviarArchivo([archivo], paraDestino);
        },

        abrirDialogEnviarArchivosSeleccionados() {
            const archivos = this.getArchivosSeleccionadosParaEnvio();
            if (archivos.length === 0) return;
            this.inicializarDialogEnviarArchivo(archivos);
        },

        getNombrePresupuesto(archivo) {
            if (!archivo) return 'presupuesto';
            return archivo.nombre || this.getNombreArchivo(archivo.url) || 'presupuesto';
        },

        abrirDialogAgencia(archivo, accion) {
            if (!archivo || !archivo.url) return;

            this.archivoAEnviarAgencia = archivo;
            this.dialogContactarAgencia = true;
            this.enviandoArchivoAgencia = false;
            this.envioArchivoAgenciaExitoso = false;
            this.errorEnvioArchivoAgencia = '';
            this.accionDialogAgencia = accion || '';

            const presupuesto = this.getNombrePresupuesto(archivo);
            if (accion === 'solicitar_modificacion') {
                this.tituloDialogAgencia = 'Solicitar modificación';
                this.formContactarAgencia = {
                    para: 'booking@rutasmeigas.com',
                    asunto: `Solicito modificación sobre presupuesto - ${presupuesto}`,
                    texto: ''
                };
                return;
            }

            if (accion === 'cancelar') {
                this.tituloDialogAgencia = 'Cancelar';
                this.formContactarAgencia = {
                    para: 'booking@rutasmeigas.com',
                    asunto: `Cancelacion presupuesto - ${presupuesto}`,
                    texto: ''
                };
                return;
            }

            this.tituloDialogAgencia = 'Contactar Agencia';
            this.formContactarAgencia = {
                para: 'booking@rutasmeigas.com',
                asunto: '',
                texto: ''
            };
        },

        abrirDialogSolicitarModificacion(archivo) {
            this.abrirDialogAgencia(archivo, 'solicitar_modificacion');
        },

        abrirDialogCancelarPresupuesto(archivo) {
            this.abrirDialogAgencia(archivo, 'cancelar');
        },

        getNombreDocumentoCorreo(archivo) {
            if (!archivo) return 'Documento';

            const tipo = archivo.tipo
                ? archivo.tipo.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                : '';
            const nombresPorTipo = {
                presupuesto: 'Presupuesto',
                confirmacion: 'Confirmacion',
                'bono alojamiento': 'Bono Alojamientos',
                'bono alojamientos': 'Bono Alojamientos',
                'bono servicios': 'Bonos Servicios',
                'bonos servicios': 'Bonos Servicios'
            };

            return nombresPorTipo[tipo] || archivo.nombre || this.getNombreArchivo(archivo.url) || 'Documento';
        },

        construirDocumentoCorreo(archivo) {
            if (!archivo || !archivo.url) return null;

            return {
                nombre_documento: this.getNombreDocumentoCorreo(archivo),
                url_documento: archivo.url
            };
        },

        getResumenArchivosAEnviar() {
            if (this.archivosAEnviar.length === 1) {
                return this.archivosAEnviar[0].nombre || 'Documento';
            }

            if (this.archivosAEnviar.length > 1) {
                return `${this.archivosAEnviar.length} documentos seleccionados`;
            }

            return '-';
        },

        esUltimoPresupuesto(seccion, item, index) {
            return !!seccion
                && seccion.key === 'presupuestos'
                && Array.isArray(seccion.items)
                && (
                    index === seccion.items.length - 1
                    || seccion.items[seccion.items.length - 1] === item
                );
        },

        cerrarDialogEnviarArchivo(force = false) {
            if (this.enviandoArchivo && !force) return;

            this.dialogEnviarArchivo = false;
            this.archivoAEnviar = null;
            this.archivosAEnviar = [];
            this.envioArchivoExitoso = false;
            this.errorEnvioArchivo = '';
            this.formEnviarArchivo = {
                para: '',
                asunto: '',
                texto: ''
            };
        },

        cerrarDialogContactarAgencia(force = false) {
            if (this.enviandoArchivoAgencia && !force) return;

            this.dialogContactarAgencia = false;
            this.archivoAEnviarAgencia = null;
            this.tituloDialogAgencia = 'Contactar Agencia';
            this.accionDialogAgencia = '';
            this.envioArchivoAgenciaExitoso = false;
            this.errorEnvioArchivoAgencia = '';
            this.formContactarAgencia = {
                para: '',
                asunto: '',
                texto: ''
            };
        },

        async enviarArchivoPorCorreo() {
            const para = this.formEnviarArchivo.para ? this.formEnviarArchivo.para.trim() : '';
            const asunto = this.formEnviarArchivo.asunto ? this.formEnviarArchivo.asunto.trim() : '';
            const texto = this.formEnviarArchivo.texto ? this.formEnviarArchivo.texto.trim() : '';
            const documentos = this.archivosAEnviar
                .map(archivo => this.construirDocumentoCorreo(archivo))
                .filter(Boolean);
            const reservaId = this.reservaSeleccionada && this.reservaSeleccionada.id ? this.reservaSeleccionada.id : null;

            this.errorEnvioArchivo = '';
            this.envioArchivoExitoso = false;

            if (!para || !asunto || !texto || !reservaId || documentos.length === 0) {
                this.errorEnvioArchivo = 'Debes completar Para, Asunto y Texto del Correo.';
                return;
            }

            if (!this.emailValido(para)) {
                this.errorEnvioArchivo = 'El correo de destino no tiene un formato válido.';
                return;
            }

            if (this.enviandoArchivo) return;

            this.enviandoArchivo = true;

            try {
                await Vue.axios({
                    method: 'POST',
                    url: '/enviar-correo-agencia-cliente',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + this.access_token
                    },
                    data: {
                        reserva_id: reservaId,
                        para,
                        asunto,
                        texto_correo: texto,
                        documentos
                    }
                });

                await this.refrescarTrasEnvioCorreo();
                this.envioArchivoExitoso = true;

                setTimeout(() => {
                    if (this.dialogEnviarArchivo) {
                        this.cerrarDialogEnviarArchivo();
                    }
                }, 800);
            } catch (e) {
                this.errorEnvioArchivo = 'No se pudo enviar el correo. Inténtalo de nuevo.';
            } finally {
                this.enviandoArchivo = false;
            }
        },

        async enviarCorreoAgenciaRutasMeigas() {
            const para = this.formContactarAgencia.para ? this.formContactarAgencia.para.trim() : '';
            const asunto = this.formContactarAgencia.asunto ? this.formContactarAgencia.asunto.trim() : '';
            const texto = this.formContactarAgencia.texto ? this.formContactarAgencia.texto.trim() : '';
            const url = this.archivoAEnviarAgencia && this.archivoAEnviarAgencia.url ? this.archivoAEnviarAgencia.url : '';
            const reservaId = this.reservaSeleccionada && this.reservaSeleccionada.id ? this.reservaSeleccionada.id : null;
            const esSolicitudModificacion = this.accionDialogAgencia === 'solicitar_modificacion';

            this.errorEnvioArchivoAgencia = '';
            this.envioArchivoAgenciaExitoso = false;

            if (!para || !asunto || !texto || !reservaId || (!esSolicitudModificacion && !url)) {
                this.errorEnvioArchivoAgencia = 'Debes completar Para, Asunto y Texto del Correo.';
                return;
            }

            if (!this.emailValido(para)) {
                this.errorEnvioArchivoAgencia = 'El correo de destino no tiene un formato válido.';
                return;
            }

            if (this.enviandoArchivoAgencia) return;

            this.enviandoArchivoAgencia = true;

            try {
                const data = {
                    reserva_id: reservaId,
                    para,
                    asunto,
                    texto_correo: texto
                };

                if (!esSolicitudModificacion) {
                    data.url_archivo = url;
                }

                await Vue.axios({
                    method: 'POST',
                    url: esSolicitudModificacion
                        ? '/solicitar-modificacion-agencia'
                        : '/enviar-correo-agencia-rutasmeigas',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': 'Bearer ' + this.access_token
                    },
                    data
                });

                await this.refrescarTrasEnvioCorreo();
                this.envioArchivoAgenciaExitoso = true;

                setTimeout(() => {
                    if (this.dialogContactarAgencia) {
                        this.cerrarDialogContactarAgencia();
                    }
                }, 800);
            } catch (e) {
                this.errorEnvioArchivoAgencia = 'No se pudo enviar el correo. Inténtalo de nuevo.';
            } finally {
                this.enviandoArchivoAgencia = false;
            }
        },

        addArchivoSiCorresponde(resultado, urlsVistas, archivo) {
            if (!archivo || !archivo.url || urlsVistas.has(archivo.url)) return;
            urlsVistas.add(archivo.url);
            resultado.push(archivo);
        },

        getArchivosDocumentos(reserva) {
            const resultado = [];
            const urlsVistas = new Set();
            const camino = reserva.camino || null;
            const language = reserva.language || '';

            const archivosCamino = [
                {
                    nombre: 'DOSSIER',
                    url: this.getUrlCaminoPorIdioma(camino, 'link_pdf', language),
                    tipo: 'DOSSIER',
                    fecha: null
                },
                {
                    nombre: 'TIPS',
                    url: this.getUrlCaminoPorIdioma(camino, 'link_tips_camino', language),
                    tipo: 'TIPS',
                    fecha: null
                }
            ];

            for (const archivoCamino of archivosCamino) {
                this.addArchivoSiCorresponde(resultado, urlsVistas, archivoCamino);
            }

            const fuentes = [
                { key: 'seguros', label: 'Seguro' },
                { key: 'archivos', label: 'Archivo' },
                { key: 'documentos', label: 'Documento' },
                { key: 'archivos_dossier_tips', label: 'Dossier/Tips' }
            ];

            for (const fuente of fuentes) {
                const valor = reserva[fuente.key];
                if (!Array.isArray(valor)) continue;

                for (const raw of valor) {
                    if (!this.isArchivoVisibleAgencia(raw)) continue;

                    const archivo = this.normalizarArchivo(raw, fuente.label);
                    this.addArchivoSiCorresponde(resultado, urlsVistas, archivo);
                }
            }

            return resultado;
        },

        getArchivosBonos(reserva) {
            if (!reserva) return [];

            const resultado = [];
            const urlsVistas = new Set();

            const fuentes = [
                { key: 'bonos_alojamientos', label: 'Bono alojamiento' },
                { key: 'bonos_servicios', label: 'Bono servicios' }
            ];

            for (const fuente of fuentes) {
                const valor = reserva[fuente.key];
                if (!Array.isArray(valor)) continue;

                for (const raw of valor) {
                    if (!this.isArchivoVisibleAgencia(raw)) continue;

                    const archivo = this.normalizarArchivo(raw, fuente.label);
                    this.addArchivoSiCorresponde(resultado, urlsVistas, archivo);
                }
            }

            return resultado;
        },

        getArchivosReservaPorFuente(reserva, key, label) {
            if (!reserva || !Array.isArray(reserva[key])) return [];

            const resultado = [];
            const urlsVistas = new Set();

            for (const raw of reserva[key]) {
                if (!this.isArchivoVisibleAgencia(raw)) continue;

                const archivo = this.normalizarArchivo(raw, label);
                this.addArchivoSiCorresponde(resultado, urlsVistas, archivo);
            }

            return resultado;
        },

        getSeccionesArchivosReserva(reserva) {
            if (!reserva) {
                return this.seccionesArchivosReserva.map(seccion => ({ ...seccion, items: [] }));
            }

            return this.seccionesArchivosReserva.map((seccion) => {
                let items = [];

                if (seccion.key === 'documentos') {
                    items = this.getArchivosDocumentos(reserva);
                }

                if (seccion.key === 'bonos') {
                    items = this.getArchivosBonos(reserva);
                }

                if (seccion.key === 'presupuestos') {
                    items = this.getArchivosReservaPorFuente(reserva, 'presupuestos', 'Presupuesto');
                }

                if (seccion.key === 'confirmaciones') {
                    items = this.getArchivosReservaPorFuente(reserva, 'confirmaciones', 'Confirmación');
                }

                if (seccion.key === 'proformas') {
                    items = this.getArchivosReservaPorFuente(reserva, 'proformas', 'Proforma');
                }

                return {
                    ...seccion,
                    items
                };
            });
        },

        getLinkRegistroViajeros(item) {
            if (!item || !item.link_registro_viajeros) return null;

            const language = item.language ? item.language.toString().trim().toLowerCase() : '';
            const hash = item.hash ? item.hash.toString().trim() : '';
            if (!language || !hash) return null;

            const base = item.link_registro_viajeros.toString().trim().replace(/\/+$/, '');
            return `${base}/${language}/${hash}`;
        },

        getRutaRegistroViajerosAgencia(item) {
            if (!item) return null;

            const language = item.language ? item.language.toString().trim().toLowerCase() : '';
            const hash = item.hash ? item.hash.toString().trim() : '';
            const agencia = this.$route && this.$route.params ? this.$route.params.agencia : '';
            const codigo = item.codigo ? item.codigo.toString().trim() : '';
            if (!language || !hash) return null;

            return {
                name: 'registroViajerosAgencia',
                params: {
                    language,
                    hash
                },
                query: {
                    agencia,
                    codigo
                }
            };
        },

        irARegistroViajerosAgencia(item) {
            const ruta = this.getRutaRegistroViajerosAgencia(item);
            if (!ruta) return;

            const resolvedRoute = this.$router.resolve(ruta);
            window.open(resolvedRoute.href, '_blank', 'noopener,noreferrer');
        },

        async obtenerDetalleReserva(reservaId) {
            const response = await Vue.axios({
                method: 'GET',
                url: `/getReservaModuloAgencias/${reservaId}`,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + this.access_token
                }
            });
            const payload = response && response.data ? response.data : null;
            if (!payload) return null;
            return payload.data || payload;
        },

        async abrirDetalleReserva(item, { syncRoute = true } = {}) {
            this.codigoDetalleActual = this.normalizarCodigo(item && item.codigo);
            this.limpiarArchivosSeleccionados();
            this.editandoCliente = false;
            this.resetEstadoActualizarCliente();
            this.resetFormCliente();

            this.dialogDetalle = true;
            this.loadingDetalle = true;
            this.reservaSeleccionada = null;

            if (syncRoute) {
                this.actualizarRutaDetalle(this.codigoDetalleActual);
            }

            try {
                const detalleReserva = await this.obtenerDetalleReserva(item.id);
                this.reservaSeleccionada = detalleReserva || item;
                this.resetFormCliente();
            } catch (e) {
                this.reservaSeleccionada = item || null;
                this.resetFormCliente();
            } finally {
                this.loadingDetalle = false;
            }
        },

        cerrarDetalleReserva(syncRoute = true) {
            this.cerrarDialogEnviarArchivo(true);
            this.cerrarDialogContactarAgencia(true);
            this.cerrarDialogHistorial();
            this.dialogDetalle = false;
            this.loadingDetalle = false;
            this.reservaSeleccionada = null;
            this.codigoDetalleActual = '';
            this.editandoCliente = false;
            this.guardandoCliente = false;
            this.resetEstadoActualizarCliente();
            this.resetFormCliente();
            this.limpiarArchivosSeleccionados();

            if (syncRoute) {
                this.actualizarRutaDetalle(null);
            }
        }
    }
};
</script>

<style scoped>
.alternating-rows ::v-deep tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, 0.02);
}

.alternating-rows >>> tbody tr:nth-child(even) {
    background-color: #ebebeb !important;
}

.bordered-table ::v-deep td,
.bordered-table ::v-deep th {
    border-bottom: 1px solid #e0e0e0;
}

.tabla-filtros-row td {
    padding: 8px 6px !important;
    background-color: rgba(251, 250, 241, 0.9);
}

.tabla-filtro-input {
    min-width: 90px;
}

.tabla-filtro-input ::v-deep .v-input__slot {
    min-height: 34px !important;
}

.fechas-container {
    line-height: 1.2;
}

.fecha-inicio,
.fecha-llegada {
    white-space: nowrap;
}

.habitaciones-icon {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 30px;
}

.habitaciones-count {
    position: absolute;
    bottom: -10px;
    right: -10px;
    font-size: 11px;
    font-weight: 700;
}

.detalle-reserva-card {
    border-radius: 14px;
}

.detalle-grid {
    display: grid;
    grid-template-columns: 160px 1fr;
    row-gap: 8px;
    column-gap: 10px;
    font-size: 0.9rem;
}

.detalle-label {
    color: #546e7a;
    font-weight: 600;
}

.h-100 {
    height: 100%;
}

.ticket-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
}

.ticket-subtitle {
    font-size: 0.78rem;
    color: #607d8b;
    margin-bottom: 6px;
}

.ticket-description {
    font-size: 0.83rem;
    color: #455a64;
    line-height: 1.3;
}

.archivos-actions {
    min-width: 140px;
}

.historial-descripcion {
    display: inline-block;
    white-space: normal;
    line-height: 1.35;
}

.historial-correo-texto {
    max-height: 70vh;
    overflow-y: auto;
    white-space: normal;
    line-height: 1.5;
}

.tooltip-content {
    max-width: 320px;
    white-space: pre-line;
    line-height: 1.35;
}
</style>
